import { Toast } from "primereact/toast";
import { createContext, type RefObject } from "react";

export const ToastContext = createContext<RefObject<Toast | null> | null>(null);
